import { editTask, priorityOptions, taskPriorityEnum } from '@/services/task/task'
import { Select } from 'antd'
import classnames from 'classnames'
import { memo, useEffect, useState } from 'react'
import styles from './index.module.less'

export default memo(function TaskPriority(props: any) {
  const { task, editable = true, onSuccess } = props
  const [editing, setEditing] = useState(props.editing || false)
  const [value, setValue] = useState<any>()

  useEffect(() => {
    setValue(task.priority)
  }, [task])

  const handleChange = async (newValue) => {
    if (newValue) {
      const data = await editTask(task.id, { priority: newValue })
      onSuccess?.(data)
      setEditing(false)
      setValue(newValue)
    } else {
      setEditing(false)
    }
  }

  if (editing) {
    return (
      <Select
        className='w100'
        autoFocus
        value={value}
        onChange={(newValue) => {
          handleChange(newValue)
        }}
        onBlur={() => {
          setEditing(false)
        }}
        open={true}
      >
        {priorityOptions.map((item) => (
          <Select.Option value={item.value} key={item.value}>
            {item.label}
          </Select.Option>
        ))}
      </Select>
    )
  }

  return (
    <div
      className={styles.fieldItem}
      onClick={() => {
        if (editable) {
          setEditing(true)
        }
      }}
    >
      {value && (
        <span className={classnames(styles.taskPriority, styles[taskPriorityEnum[value]])}>
          {taskPriorityEnum[value]}
        </span>
      )}
    </div>
  )
})
